<template>
  <div class="compressed-content">
    <h3>Are you on any medication to manage your blood sugar?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.isOnMedication">
      <b-form-radio v-model="survey.bloodSugar.isOnMedication" name="yes" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.bloodSugar.isOnMedication" name="no" :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    validations: {
      isOnMedication: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      isOnMedication() { return this.survey.bloodSugar.isOnMedication; }
    }
  };
</script>